"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEmail = void 0;
const parseEmail = (email) => {
    const [address, domain] = email.split('@');
    const companyDomain = domain !== 'gmail.com' ? domain : '';
    return {
        address,
        domain,
        companyDomain
    };
};
exports.parseEmail = parseEmail;
//# sourceMappingURL=parseEmail.js.map